import React, { useEffect, useState } from "react";
import { Modal, Descriptions, Table, Tag, Spin, Badge } from "antd";
import dayjs from "dayjs";
import PoolDataService from "src/services/PoolDataService";
import ReportPoolDataService from "src/services/ReportPoolDataService";

const DetailModalOpen = ({ open, onCancel, id }) => {
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    if (open && id) {
      fetchDetail();
    }
  }, [open, id]);

  const fetchDetail = async () => {
    try {
      setLoading(true);
      const res = await ReportPoolDataService.getDetailReportPackageReceiptM2M(id);
      setDetail(res.success);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const statusMap = {
    0: { text: "Chưa kích hoạt", status: "warning" },
    1: { text: "Đã kích hoạt", status: "success" },
    2: { text: "Đã hủy", status: "error" },
  };

  return (
    <Modal
      title="Chi tiết báo cáo nhập SIM"
      open={open}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "40px 0" }}>
          <Spin size="large" />
        </div>
      ) : (
        detail && (
          <Descriptions bordered column={2}>
            <Descriptions.Item label="Mã phiếu nhập kho" span={2}>
              {detail.code}
            </Descriptions.Item>

            <Descriptions.Item label="Mã gói cước">
              {detail.package_code}
            </Descriptions.Item>

            <Descriptions.Item label="Loại gói">
              {detail.package_type}
            </Descriptions.Item>

            <Descriptions.Item label="Dung lượng">
              {detail.data_volume_gb} GB
            </Descriptions.Item>

            <Descriptions.Item label="SĐT SIM chủ">
              {detail.parent_phone}
            </Descriptions.Item>

            <Descriptions.Item label="Giá nhập">
              {Number(detail.import_price).toLocaleString()} đ
            </Descriptions.Item>

            <Descriptions.Item label="Giá trị chiết khấu">
              {detail.discount_type === "percent"
                ? `${detail.discount_value}%`
                : `${Number(detail.discount_value).toLocaleString()} đ`}
            </Descriptions.Item>

            <Descriptions.Item label="Giá sau giảm" span={2}>
              {Number(detail.total_price).toLocaleString()} đ
            </Descriptions.Item>

            <Descriptions.Item label="Người tạo">
              {detail.customer?.fullname}
            </Descriptions.Item>

            <Descriptions.Item label="Trạng thái">
              <Badge
                status={statusMap[detail.status]?.status}
                text={statusMap[detail.status]?.text}
              />
            </Descriptions.Item>

            <Descriptions.Item label="Ghi chú" span={2}>
              {detail.note}
            </Descriptions.Item>

            <Descriptions.Item label="Ngày tạo">
              {dayjs(detail.created_at).format("DD/MM/YYYY HH:mm")}
            </Descriptions.Item>

            <Descriptions.Item label="Cập nhật lần cuối">
              {dayjs(detail.updated_at).format("DD/MM/YYYY HH:mm")}
            </Descriptions.Item>
          </Descriptions>
        )
      )}
    </Modal>
  );
};

export default DetailModalOpen;
